<div class="search-container w-100">
  <span class="p-input-icon-left w-100">
        <i class="pi pi-search" *ngIf="!onSearching"></i>
        <i class="pi pi-spin pi-spinner" *ngIf="onSearching"></i>
        <input type="text" pInputText (keyup)="filterChanged.emit($event.target.value)" [placeholder]="placeholder" />
    </span>
</div>
